// Every issue a proposal carries, each linked by its key, in the server's
// order (Poulpe-456, Poulpe-554): `A`, `A and B`, `A, B and C`. One the page
// does not hold yet shows its id, so none is hidden.
import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import type { Proposal } from '../api/types'
import { useBoardState } from '../store/context'
import { carried } from './words'

export function CarriedIssues({ proposal, className, skipFirst = false }: { proposal: Pick<Proposal, 'issue_id' | 'issue_ids'>; className?: string; skipFirst?: boolean }) {
  const { issues } = useBoardState()
  const all = carried(proposal, issues).slice(skipFirst ? 1 : 0)
  return <>{all.map(({ id, issue }, i) => <Fragment key={id}>
    {i > 0 && (i === all.length - 1 ? ' and ' : ', ')}
    {issue ? <Link className={className} to={`/${encodeURIComponent(issue.key)}`}>{issue.key}</Link> : <code title="An issue this page has not loaded yet">{id}</code>}
  </Fragment>)}</>
}
